import { useEffect, useRef, useState } from "react";

const LOCATION_PHRASES = [
  "Zagreb",
  "Split",
  "Maksimir",
  "Špansko",
  "Splitsko-dalmatinska",
  "Istarska",
];

const TYPING_SPEED = 80;
const DELETING_SPEED = 40;
const PAUSE_AFTER_TYPING = 1500;
const PAUSE_AFTER_DELETING = 350;

export function useAnimatedLocationPlaceholder(isActive: boolean): string {
  const [displayText, setDisplayText] = useState("");
  const phraseIndex = useRef(0);
  const charIndex = useRef(0);
  const isDeleting = useRef(false);

  useEffect(() => {
    if (!isActive) {
      setDisplayText("");
      phraseIndex.current = 0;
      charIndex.current = 0;
      isDeleting.current = false;
      return undefined;
    }

    let timeoutId;

    const tick = () => {
      const currentPhrase = LOCATION_PHRASES[phraseIndex.current];

      if (!isDeleting.current) {
        charIndex.current += 1;
        setDisplayText(currentPhrase.slice(0, charIndex.current));

        if (charIndex.current === currentPhrase.length) {
          isDeleting.current = true;
          timeoutId = setTimeout(tick, PAUSE_AFTER_TYPING);
          return;
        }
        timeoutId = setTimeout(tick, TYPING_SPEED);
      } else {
        charIndex.current -= 1;
        setDisplayText(currentPhrase.slice(0, charIndex.current));

        if (charIndex.current === 0) {
          isDeleting.current = false;
          phraseIndex.current = (phraseIndex.current + 1) % LOCATION_PHRASES.length;
          timeoutId = setTimeout(tick, PAUSE_AFTER_DELETING);
          return;
        }
        timeoutId = setTimeout(tick, DELETING_SPEED);
      }
    };

    timeoutId = setTimeout(tick, PAUSE_AFTER_DELETING);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isActive]);

  return displayText;
}



// WEBPACK FOOTER //
// ./src/components/FormControls/SearchInputLocation/useAnimatedLocationPlaceholder.ts